import { useUnresolvedQuery } from "api";

export const useUnresolvedRefetch = () => {
  const { refetch } = useUnresolvedQuery({ fetchPolicy: "network-only", skip: true });
  return refetch;
};
